import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=60ec9b8e&scoped=true"
import script from "./Common.vue?vue&type=script&lang=js"
export * from "./Common.vue?vue&type=script&lang=js"
import style0 from "./Common.vue?vue&type=style&index=0&id=60ec9b8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec9b8e",
  null
  
)

export default component.exports